/**
 * Mentor.jsx — Professor Prayog, the park's Chief Engineer.
 * A warm dialogue bubble used on the Park Map, finish screens, etc.
 */
export default function Mentor({ text, mood = "happy", compact = false }) {
  const face = { happy: "👨‍🔬", proud: "🥹", thinking: "🤔", alert: "⚠️" }[mood] || "👨‍🔬";
  return (
    <div
      data-testid="mentor-bubble"
      style={{
        display: "flex",
        gap: 12,
        alignItems: "flex-start",
        background: "rgba(232,121,249,0.07)",
        border: "1px solid rgba(232,121,249,0.35)",
        borderRadius: 16,
        padding: compact ? "10px 14px" : "14px 18px",
        margin: "10px 0",
        textAlign: "left",
      }}
    >
      <div
        style={{
          fontSize: compact ? 26 : 34,
          lineHeight: 1,
          filter: "drop-shadow(0 0 6px rgba(232,121,249,0.4))",
        }}
      >
        {face}
      </div>
      <div>
        <div style={{ fontSize: 10.5, letterSpacing: 2, color: "#e879f9", fontWeight: 800, marginBottom: 3 }}>
          PROF. PRAYOG · CHIEF ENGINEER
        </div>
        <div style={{ fontSize: compact ? 13 : 14, color: "#e8ecf3", lineHeight: 1.6 }}>
          {text}
        </div>
      </div>
    </div>
  );
}
